import { ChevronDown } from 'lucide-react';
import type { ComponentPropsWithoutRef, Ref } from 'react';
import { cx } from '../../utils/cx';
import { useFieldProps } from '../FormField/FormField';
import { Icon } from '../Icon/Icon';
import s from './Select.module.css';

export type SelectProps = ComponentPropsWithoutRef<'select'> & { ref?: Ref<HTMLSelectElement> };

/** A styled native <select>: the platform picker is the best experience on phones. */
export function Select({ className, children, ...rest }: SelectProps) {
  const props = useFieldProps(rest);
  return (
    <div className={cx(s.wrap, className)}>
      <select className={s.select} {...props}>
        {children}
      </select>
      <Icon icon={ChevronDown} size="md" className={s.chevron} />
    </div>
  );
}
